module.exports = __webpack_public_path__ + "static/media/microvista_logo.2ddb62f7.png";